import request, { gql } from "graphql-request";

export const CREATEROLE = gql`
  mutation CreateRole($input: RoleInput!) {
    createRole(input: $input) {
      success
      message
      error
    }
  }
`;

export const GETROLE = gql`
  query GetAllRoles($search: String!, $page: Int!, $pageSize: Int!) {
    allRoles(search: $search, page: $page, pageSize: $pageSize) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      dataList {
        id
        roleName
        status
        permission
      }
    }
  }
`;

export const GETROLEBYID = gql`
 query GetRoleById($id: ID!) {
  getRoleById(id: $id) {
    success
    error
    message
    data {
      id
      roleName
      status
      permission
 
    }
  }
}
`;

export const DELETEROLE = gql`
  mutation DeleteRole($input: UpdateRoleInput!) {
  deleteRole(input: $input) {
    success
    error
    message

  }
}
`;

export const UPDATEROLE = gql`
  mutation UpdateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
    success
    error
    message
    data {
      id
      roleName
      status

    }
  }
}
`;
